import styled from 'styled-components';
import ScrollableWrapper from '../../../components/ScrollableWrapper';

export const DashboardNavContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  height: 100%;
  width: 100%;
  padding-top: 12px;
`;

export const FixedSection = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding-left: 12px;
  padding-right: 12px;
`;

export const ScrollableSection = styled(ScrollableWrapper)`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  overflow-y: auto;
  flex-grow: 1;
  padding-left: 12px;
  padding-right: 12px;
`;
